import React from 'react'
import { withTranslation } from 'react-i18next';
import {Footer, SignupDivider, HeroPlain, Location} from '../../components';
import {WebLayout} from '../../layouts';

const AboutPage = ({t}) => (
  <WebLayout alwaysSticky={true}
  		link={[{
          rel: "alternate", href: "https://www.duuers.com/fi/about", hreflang: "fi"
      },{
          rel: 'alternate', href: 'https://www.duuers.com/en/about', hreflang: 'en'
      },{
          rel: 'alternate', href: 'https://www.duuers.com/en/about', hreflang: 'x-default'
      }]}
    >
    <HeroPlain background="/images/hero_team.jpg">
      <h1 className={"font_second semibold font40 white"}>{t('about.header')}</h1>
    </HeroPlain>
    <section className="content_4 bg_white padding_bottom25">
      <div className="container nopadding max_width970 text-center">
        <h2 className="top50 font_second light font42">Meidän tarina</h2>
        <div className="max_width770 margin_auto top45 font22 light text">
          Me Duuersissa uskomme, että avain menestykseen löytyy tekemällä asioita fiksummin, ei kovemmin.
          <br></br>
          <br></br>
          Kaikki alkoi seuraamalla yrittäjien hektistä arkea ja “ahaa”-elämyksestä huonosti tehtyjä tarjouksia ja erityisesti kuormittavia työkaluja kohtaan! Kehitimme tätä varten helppokäyttöisen palvelun, joka on rakennettu yhdessä yrittäjien kanssa helpottamaan heidän arkeaan ja vapauttamaan kallisarvoista aikaa.
          <br></br>
          <br></br>
          Aloitimme toimintamme 2017 ja Suomen lisäksi olemme juuri aloittaneet toimintamme myös Kanadassa.
        </div>
      </div>
    </section>
    <section className="team_1 bg_white padding_top100 padding_bottom15">
      <div className="container nopadding text-center dark_gray">
        <h2 className="font42 font_second light">Meidän perustajat</h2>
        <div className="max_width770 margin_auto top35 font22 light dark_blue hyphens text">
          Meitä yhdistää halu haastaa turhaan kuormittavia vanhoja tapoja. Haluamme ratkaista oikeita ongelmia luomalla helppokäyttöisiä työkaluja, joita kuka tahansa osaa käyttää. Asiakkaiden positiivinen palaute on paras kannustin tehdä vieläkin parempaa!
        </div>
        <div className="top65 flex justify_between inner">
          <div className="width370 margin_auto bottom70 radius10 padding_top50 padding_bottom50 block">
            <img src={"/images/paula.jpeg"} className="radius_full"  alt="Founder profile picture" />
            <div className="top25 font22 light title"><a href="https://fi.linkedin.com/in/paulaviinamaki" target="blank">Paula Viinamäki</a></div>
            <div className="top15 font12 semibold uppercase spacing10 dark_blue">Perustaja, Toimitusjohtaja</div>
          </div>
          <div className="width370 margin_auto bottom70 radius10 padding_top50 padding_bottom50 block">
            <img src="/images/jussi.jpeg" className="radius_full" alt="Co-Founder profile picture" />
            <div className="top25 font22 light title"><a href="https://fi.linkedin.com/in/jussi-paanaj%C3%A4rvi" target="blank">Jussi Paanajärvi</a></div>
            <div className="top15 font12 semibold uppercase spacing10 dark_blue">Perustaja, Tuotejohtaja</div>
          </div>
        </div>
      </div>
    </section>

    <Location/>
    <section className="contact_2 bg_white padding_top25 padding_bottom70">
      <div className="container nopadding max_width970 dark_blue text-center">
        <h2 className="top20 font42 font_second light">Ota yhteyttä</h2>
        <div className="max_width770 margin_auto top35 font22 light dark_blue hyphens text">
          Jos tarvitset apua aloituksen kanssa, haluat keskustella yhteistyöstä tai olet kiinnostunut tulemaan meille töihin, niin laita viestiä!
        </div>
        <div className="row top85">
          <div className="col-md-4 bottom50">
            <div className="font_second semibold font18 dark_gray title">
              <a href="https://intercom.help/duuers/fi/" target="blank">Tuki</a>
            </div>
            <div className="max_width270 margin_auto top10 font16 light text">
              Ma - Pe, 9:00 - 17:00 <br/>
              support@duuers.com
            </div>
          </div>
          <div className="col-md-4 bottom50">
            <div className="font_second semibold font18 dark_gray title">Markkinointi & Partnerit</div>
            <div className="max_width270 margin_auto top10 font16 light text">
              Paula Viinamäki<br/>
              paula@duuers.com
            </div>
          </div>
          <div className="col-md-4 bottom50">
            <div className="font_second semibold font18 dark_gray title">
              <a href="https://thehub.fi/jobs/company/duuers" target="blank">Avoimet työpaikat</a>
            </div>
            <div className="max_width270 margin_auto top10 font16 light text">
              Paula Viinamäki, CEO <br/>
              paula@duuers.com
            </div>
          </div>
        </div>
      </div>
    </section>
    <SignupDivider/>
    <Footer/>
  </WebLayout>
)
export default withTranslation()(AboutPage)
